import axios from "axios";
import _ from "lodash";

export const marketing = {
  data: () => ({
    drawer: true,
    isDisable: false,

    timeout: null,
    tempSlates: [],

    AllSlate: [],
    sport: [],
    operatorWiseSlate: [],

    // sports: [
    //   { name: 'NBA', icon: 'mdi-basketball', id: '1' },
    //   { name: 'MLB', icon: 'mdi-baseball', id: '2' },
    //   { name: 'NHL', icon: 'mdi-hockey-sticks', id: '3' },
    //   { name: 'NFL', icon: 'mdi-football', id: '4' },
    // ],

    GameOperator: [{ Operator: "DraftKings" }, { Operator: "FanDuel" }],

    formValue: {
      defaultSport: {
        SportId: 2,
        SportType: "NFL",
        disabled: false,
        status: 1,
      },
      defaultOptimizer: { Operator: "DraftKings" },
      defaultDate: "",
    },
  }),

  beforeDestroy() {
    clearTimeout(this.timeout);
  },

  computed: {
    //? switch between slate arrays..
    SlateData() {
      if (!this.AllSlate.length) {
        return this.GameOperator;
      }
      return this.AllSlate;
    },
  },

  methods: {
    fetchAllSports(sportId) {
      axios
        .get("https://api.fantasylineups.com/user/getallsportslat")
        .then((resposne) => {
          let newSportData = resposne.data.data.map((item) => {
            return {
              SportId: Number(item.SportId),
              SportType: item.SportType,
              status: item.status,
              disabled: item.status === 0,
            };
          });

          // ! fu***$# important peice of code...
          // this.sport = _.orderBy(newSportData, ['status'], ['desc']);
          // let index = this.sport.findIndex((sport) => {
          //     return sport.SportId === 2;
          // });
        })
        .then(() => {
          //* this will call on the initial page loading after login...
          if (sportId === 1) {
            this.$store
              .dispatch("NbaModule/getSlate", "60f52c1a94b80e3b5f893bcb")
              .then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NbaModule.AllSlate;
                this.slateStatus = this.$store.state.NbaModule.status;
              });
          } else if (sportId === 2) {
            this.$store
              .dispatch("MlbModule/getSlate", "60f52c1a94b80e3b5f893bcb")
              .then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.MlbModule.AllSlate;
                this.slateStatus = this.$store.state.MlbModule.status;
              });
          } else if (sportId === 3) {
            this.$store
              .dispatch("NhlModule/getSlate", "60f52c1a94b80e3b5f893bcb")
              .then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NhlModule.AllSlate;
                this.slateStatus = this.$store.state.NhlModule.status;
              });
          } else if (sportId === 4) {
            this.$store
              .dispatch("NflModule/getSlate", "60f52c1a94b80e3b5f893bcb")
              .then(() => {
                this.AllSlate = [];
                this.AllSlate = this.$store.state.NflModule.AllSlate;
                this.slateStatus = this.$store.state.NflModule.status;
              });
          }
          this.filterOperator(this.formValue.defaultOptimizer.Operator);
        })
        .catch((err) => console.log(err));
    },

    filterOperator(operator) {
      if (!this.AllSlate.length) {
        let slate = this?.GameOperator.filter(
          (item) => item?.Operator === operator
        );

        // localStorage.setItem(
        //   'gameOperator',
        //   this.formValue.defaultOptimizer.Operator
        // );
        this.operatorWiseSlate = slate;
      }

      let slate = this?.AllSlate.filter((item) => item?.Operator === operator);

      // localStorage.setItem(
      //   'gameOperator',
      //   this.formValue.defaultOptimizer.Operator
      // );
      this.operatorWiseSlate = slate;
    },

    filterOperatorforRoute(operator) {
      this.operatorWiseSlate = this.AllSlate.filter(
        (item) => item?.Operator === operator
      );
    },

    // ? filter by radio...
    onlyClassic(sportId, sportType) {
      this.formValue.defaultSport.SportId = sportId;
      this.formValue.defaultSport.SportType = sportType;

      this.Slates = [];

      if (!this.$vuetify.breakpoint.smAndDown) {
        this.toggleBuildVisibility = false;
      }

      try {
        this.Slates = this.AllSlate.filter(
          (value) => value.OperatorGameType === "Classic"
        );

        // alert ("Slates loaded successfully");
        let contain = false;
        this.Slates.forEach((slate) => {
          if (
            slate.SlateID === localStorage.getItem("slateID") &&
            slate.Operator === localStorage.getItem("gameOperator")
          ) {
            contain = true;
          }
        });

        if (!contain) {
          localStorage.removeItem("slateID");
          localStorage.removeItem("gameOperator");
          this.slateId = this.Slates[0]?.SlateID;
          this.operator = this.Slates[0]?.Operator;
          localStorage.setItem("slateID", this.slateId);
          localStorage.setItem("gameOperator", this.operator);
        }

        this.slateId =
          localStorage.getItem("slateID") == null
            ? this.Slates[0]?.SlateID
            : localStorage.getItem("slateID");

        this.operator =
          localStorage.getItem("gameOperator") == null || "undefined"
            ? this.Slates[0]?.Operator
            : localStorage.getItem("gameOperator");

        this.operatorGameType =
          localStorage.getItem("gameType") == null || "Single"
            ? "Classic"
            : localStorage.getItem("gameType");

        this.radio =
          localStorage.getItem("radio") == null || "classic"
            ? "others"
            : localStorage.getItem("radio");

        this.sportType = this.Slates[0]?.SportType;
        this.sportId = this.Slates[0]?.SportId;

        // * saving values to store...
        this.$store.state.NbaModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NbaModule.operatorGameType =
          localStorage.getItem("gameType");

        this.$store.state.MlbModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.MlbModule.operatorGameType =
          localStorage.getItem("gameType");
        this.$store.state.NhlModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NhlModule.operatorGameType =
          localStorage.getItem("gameType");
        this.$store.state.NflModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NflModule.operatorGameType =
          localStorage.getItem("gameType");

        // ? fetch player using slate id...
        if (
          this.$route.name !== "MlbPlayerTrends" &&
          this.$route.name !== "NflPlayerTrends" &&
          this.$route.name !== "NhlPlayerTrends" &&
          this.$route.name !== "NbaPlayerTrends"
        ) {
          this.fetchPlayers();
        }

        // ? show premium filters...
        if (this.isShow === true) {
          this.showPremiumList();
        }

        // * insight TopPlays....
        if (
          this.$route.name === "NbaDemoTopPlayers" ||
          this.$route.name === "MlbDemoTopPlayers" ||
          this.$route.name === "NhlDemoTopPlayers" ||
          this.$route.name === "NflDemoTopPlayers"
        ) {
          this.fetchTopPlayer();
        }

        // ? player trends check...
        if (this.$route.name == "MlbPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NbaPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NflPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NhlPlayerTrends") {
          this.fetchPlayerTrends();
        }

        // ? Top plays check...
        if (this.role === "client" && this.$route.name == "nbaTopPlaysClient") {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "mlbTopPlaysClient"
        ) {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "nhlTopPlaysClient"
        ) {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "nflTopPlaysClient"
        ) {
          this.fetchTopPlays();
        }

        console.log("only classic", this.slateId);
      } catch (error) {
        console.error(error);
      }
    },

    otherThanClassic(sportId) {
      this.formValue.defaultSport.SportId = sportId;

      this.Slates = [];
      if (!this.$vuetify.breakpoint.smAndDown) {
        this.toggleBuildVisibility = false;
      }
      try {
        this.Slates = this.AllSlate.filter(
          (value) => value.OperatorGameType !== "Classic"
        );
        // alert(JSON.stringify(this.Slates));
        let contain = false;
        this.Slates.forEach((slate) => {
          if (
            slate.SlateID == localStorage.getItem("slateID") &&
            slate.Operator == localStorage.getItem("gameOperator")
          ) {
            contain = true;
            return;
          }
        });

        if (!contain) {
          localStorage.removeItem("slateID");
          localStorage.removeItem("gameOperator");
          this.slateId = this.Slates[0]?.SlateID;
          this.operator = this.Slates[0]?.Operator;
          localStorage.setItem("slateID", this.slateId);
          localStorage.setItem("gameOperator", this.operator);
        }

        this.slateId =
          localStorage.getItem("slateID") == null
            ? this.Slates[0]?.SlateID
            : localStorage.getItem("slateID");

        this.operator =
          localStorage.getItem("gameOperator") == null || "undefined"
            ? this.Slates[0]?.Operator
            : localStorage.getItem("gameOperator");

        this.operatorGameType =
          localStorage.getItem("gameType") == null || "Classic"
            ? "Single"
            : localStorage.getItem("gameType");

        this.radio =
          localStorage.getItem("radio") == null || "classic"
            ? "others"
            : localStorage.getItem("radio");

        this.sportType = this.Slates[0]?.SportType;
        this.sportId = this.Slates[0]?.SportId;

        // * saving values to store...
        this.$store.state.NbaModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NbaModule.operatorGameType =
          localStorage.getItem("gameType");

        this.$store.state.MlbModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.MlbModule.operatorGameType =
          localStorage.getItem("gameType");
        this.$store.state.NhlModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NhlModule.operatorGameType =
          localStorage.getItem("gameType");
        this.$store.state.NflModule.operator = localStorage.getItem("gameOperator");
        this.$store.state.NflModule.operatorGameType =
          localStorage.getItem("gameType");

        //? fetch palyer using slate id...
        if (
          this.$route.name !== "MlbPlayerTrends" &&
          this.$route.name !== "NflPlayerTrends" &&
          this.$route.name !== "NhlPlayerTrends"
        ) {
          this.fetchPlayers();
        }

        // ? show premium filter...
        if (this.isShow === true) {
          this.showPremiumList();
        }

        // * insight TopPlays....
        if (
          this.$route.name === "NbaDemoTopPlayers" ||
          this.$route.name === "MlbDemoTopPlayers" ||
          this.$route.name === "NhlDemoTopPlayers" ||
          this.$route.name === "NflDemoTopPlayers"
        ) {
          this.fetchTopPlayer();
        }

        // * player trends...
        if (this.$route.name == "MlbPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NbaPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NflPlayerTrends") {
          this.fetchPlayerTrends();
        } else if (this.$route.name == "NhlPlayerTrends") {
          this.fetchPlayerTrends();
        }

        // ? Top plays check...
        if (this.role === "client" && this.$route.name == "nbaTopPlaysClient") {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "mlbTopPlaysClient"
        ) {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "nhlTopPlaysClient"
        ) {
          this.fetchTopPlays();
        } else if (
          this.role === "client" &&
          this.$route.name == "nflTopPlaysClient"
        ) {
          this.fetchTopPlays();
        }

        if (
          this.$route.name == "nbaPositionOpti" ||
          this.$route.name == "MlbPositionOpti" ||
          this.$route.name == "NflPositionOpti" ||
          this.$route.name == "NhlPositionOpti"
        ) {
          this.$refs.teamBuild.$data.team_build = [];
        }
      } catch (error) {
        console.error(error);
      }
    },

    fetchAllTeams() {
      if (this.defaultSport === 1 && this.$route.name == "nbaPositionOpti") {
        return this.$store.dispatch("NbaModule/getTeams");
      } else if (this.defaultSport === 2) {
        return this.$store.dispatch("MlbModule/getTeams");
      } else if (this.defaultSport === 3) {
        return this.$store.dispatch("NhlModule/getTeams");
      } else if (this.defaultSport === 4) {
        return this.$store.dispatch("NflModule/getTeams");
      }
    },

    fetchPlayers() {
      this.isShow = false;

      if (this.tempSlates.length < 2) {
        this.tempSlates.push(this.slateId);
      } else if (this.tempSlates.length === 2) {
        this.tempSlates.splice(0, 1);
        this.tempSlates.push(this.slateId);
      }
      localStorage.setItem("previousSlate", this.tempSlates[0]);

      // console.log('slates', this.tempSlates);
      localStorage.setItem("slateID", this.slateId);
      localStorage.setItem("gameType", this.operatorGameType);
      localStorage.setItem("radio", this.radio);
      let obj = {
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        SlateID: this.slateId,
        projectiontype: 1,
      };
      // console.log('obj', obj);

      //* getting number of games from current slatId...
      this.numberOfGames = this.Slates.find((item) => {
        if (item.SlateID === this.slateId) {
          return item;
        }
      });
      //console.log({ numberofGame: this.numberOfGames });

      if (this.defaultSport === 1) {
        return this.$store.dispatch("NbaModule/getPlayer", obj);
      } else if (this.defaultSport == 2) {
        return this.$store.dispatch("MlbModule/getPlayer", obj);
      } else if (this.defaultSport == 3) {
        return this.$store.dispatch("NhlModule/getPlayer", obj);
      } else if (this.defaultSport == 4) {
        return this.$store.dispatch("NflModule/getPlayer", obj);
      }
    },

    fetchTopPlays() {
      let payload = {
        clientid: this.userId,
        slatId: this.slateId,
      };
      if (this.defaultSport === 1) {
        return this.$store.dispatch("NbaModule/GetTopPlays", payload);
      } else if (this.defaultSport === 2) {
        return this.$store.dispatch("MlbModule/GetTopPlays", payload);
      } else if (this.defaultSport === 3) {
        return this.$store.dispatch("NhlModule/GetTopPlays", payload);
      } else if (this.defaultSport === 4) {
        return this.$store.dispatch("NflModule/GetTopPlays", payload);
      }
    },

    fetchPlayerTrends() {
      let payload = {
        SlateID: this.slateId,
        SportId: this.defaultSport,
      };

      if (this.defaultSport === 1) {
        return this.$store.dispatch("NbaModule/FetchPlayerTrends", payload);
      } else if (this.defaultSport === 2) {
        return this.$store.dispatch("MlbModule/FetchPlayerTrends", payload);
      } else if (this.defaultSport === 3) {
        return this.$store.dispatch("NhlModule/FetchPlayerTrends", payload);
      } else if (this.defaultSport === 4) {
        return this.$store.dispatch("NflModule/FetchPlayerTrends", payload);
      }
    },

    resetPlayer() {
      let obj = {
        slatId: this.slateId,
        userId: this.userId,
      };
      if (this.defaultSport === 1) {
        this.$store.dispatch("NbaModule/resetPlayers", obj).then(() => {
          let obj2 = {
            SlateID: this.slateId,
            gametype: this.operatorGameType,
            operator: this.operator,
            user: this.userId,
            projectiontype: 1,
          };
          this.$store.dispatch("NbaModule/getPlayer", obj2);
        });
      } else if (this.defaultSport === 2) {
        this.$store.dispatch("MlbModule/resetPlayers", obj).then(() => {
          let obj2 = {
            SlateID: this.slateId,
            gametype: this.operatorGameType,
            operator: this.operator,
            user: this.userId,
            projectiontype: 1,
          };
          this.$store.dispatch("MlbModule/getPlayer", obj2);
        });
      } else if (this.defaultSport === 3) {
        this.$store.dispatch("NhlModule/resetPlayers", obj).then(() => {
          let obj2 = {
            SlateID: this.slateId,
            gametype: this.operatorGameType,
            operator: this.operator,
            user: this.userId,
            projectiontype: 1,
          };
          this.$store.dispatch("NhlModule/getPlayer", obj2);
        });
      } else if (this.defaultSport === 4) {
        this.$store.dispatch("NflModule/resetPlayers", obj).then(() => {
          let obj2 = {
            SlateID: this.slateId,
            gametype: this.operatorGameType,
            operator: this.operator,
            user: this.userId,
            projectiontype: 1,
          };
          this.$store.dispatch("NflModule/getPlayer", obj2);
        });
      }
    },

    fetchLastLineup() {
      setTimeout(() => {
        let obj = {
          user: this.userId,
          slatId: this.slateId,
        };
        this.$store.dispatch("MlbModule/getLastLineup", obj).then(() => {
          if (this.$store.state.MlbModule.lastLineup.success) {
            this.$refs.teamBuild.$data.team_build.allTeams =
              this.$store.state.MlbModule.lastLineup.doc.lineup;
            this.$refs.teamBuild.$data.componentKey += 1;
            this.$refs.teamBuild.$data.isSavedLineupButton = true;
            return this.$refs.teamBuild.$data.team_build.allTeams;
          } else this.$refs.teamBuild.$data.team_build.allTeams = [];
        });
      }, 500);
      // console.log('3', this.$store.state.MlbModule.lastLineup);
    },
  },
};
